import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type DevModeState = {
  devMode: boolean;
};

type DevModeActions = {
  toggleDevMode: () => void;
  resetDevMode: () => void;
};

const initialState: DevModeState = {
  devMode: false,
};

export const createDevModeSlice: WaterlyAppStateCreator<DevModeActions, DevModeState> = (set, get) => ({
  ...initialState,
  toggleDevMode: () => {
    const { devMode } = get();
    set({ devMode: !devMode });
  },
  resetDevMode: () => {
    set(initialState);
  },
});
